import { types } from 'mobx-state-tree'

import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { COMPANY_NAME } from '../constants'
import { COLLAPSE_TABLE, IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

const CustomsDecision = types.model('CustomsDecision', {
  code: types.string,
  position: types.string,
  message: types.string,
})

const knownCodes = new Set(['00', '01', '02', '03', '04', '05', '09'])

export const CustomsDecisionUpdateActivity = types
  .compose(
    'CustomsDecisionUpdateActivity',
    Activity,
    types.model({
      customsDecisions: types.array(CustomsDecision),
    })
  )
  .views((self) => ({
    get tableText(): IActivityMessageSection {
      const tableContent = [
        ['activity-feed_shipment_position', 'activity-feed_customs_decision'],
        ...self.customsDecisions.map((decision) => [
          decision.position,
          knownCodes.has(decision.code) ? `activity-feed_customs_decision-${decision.code}` : decision.message,
        ]),
      ]

      return {
        type: COLLAPSE_TABLE,
        tableContent,
      }
    },
  }))
  .views((self) => ({
    get avatarType(): TAvatarType {
      return FORTO_AVATAR
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          variant: 'body2-medium',
          content: 'activity-feed_shipment_positions_updated',
          translate: true,
        },
        self.tableText,
      ]
    },
    get title(): IActivityTitle {
      return { text: COMPANY_NAME }
    },
  }))
